import React, { useState } from 'react';
import { Modal, Box, Button, Fab } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';


function FloatingWindow({ children, open, setOpen }) {
    const handleOpen = () => {
        setOpen(true)
    };
    const handleClose = () => {
        setOpen(false)
    };
    const fabStyle = {
        position: 'absolute',
        bottom: 18,
        right: 18,
      };
    return (<>
        <Fab sx={fabStyle} size="large" color="primary" aria-label="Cerrar camara foto" onClick={handleOpen}>
            <SettingsIcon />
        </Fab>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labellledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p:4,
                }}
            >
                {children}
                <Button onClick={handleClose}>Cerrar Ventana</Button>
            </Box>
        </Modal>
    </>);
}

export default FloatingWindow;